import { render, staticRenderFns } from "./page6.vue?vue&type=template&id=6362bd30&scoped=true"
import script from "./page6.vue?vue&type=script&lang=js"
export * from "./page6.vue?vue&type=script&lang=js"
import style0 from "./page6.vue?vue&type=style&index=0&id=6362bd30&prod&scoped=true&lang=css"
import style1 from "./page6.vue?vue&type=style&index=1&id=6362bd30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6362bd30",
  null
  
)

export default component.exports